var _path, _path2, _path3, _circle, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductAaoLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 52H35",
    stroke: "#DADADA",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 61H31",
    stroke: "#DADADA",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 70H23",
    stroke: "#DADADA",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 16.5,
    stroke: "url(#aaoLensGradient)",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 35.7L61 45",
    stroke: "url(#aaoLensGradient)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaoLensGradient",
    x1: 20,
    y1: 8,
    x2: 62,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7948AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAaoLens);
export default __webpack_public_path__ + "static/media/product_aao_lens.b9c0917b789e6a71c985f9a7864f667d.svg";
export { ForwardRef as ReactComponent };